import app from "../../firebaseConfig/firebaseConfig";
import {
    collection,
    doc,
    getCountFromServer,
    getDoc,
    getDocs,
    getFirestore,
    query,
    where,
    orderBy,
    startAfter,
    limit
} from "firebase/firestore";

const db = getFirestore(app);
const productsRef = collection(db, "products");
const q = query(productsRef);

class _ProductsManager {
    cache = {};

    async getAllProducts(force) {
        if (!force) {
            const snapshot = await getCountFromServer(productsRef);
            if (Object.keys(this.cache).length === snapshot.data().count) {
                return this.cache;
            }
        }

        const querySnapshot = await getDocs(q);
        const products = {};
        querySnapshot.forEach((doc) => {
            products[doc.data().id] = doc.data()
        });

        Object.assign(this.cache, products);
        return products;
    }

    async getValidProductsFromToLimit(lastItem, count, selectedCategories) {

        let queryObj= query(productsRef, orderBy('id'), startAfter(lastItem || null), limit(count), where('disabled', '!=', true));

        if (selectedCategories.length) {
            queryObj = query(queryObj, where('categories', 'array-contains-any', selectedCategories));
        }

        let querySnapshot = await getDocs(queryObj);

        const products = {};
        querySnapshot.forEach((doc) => {
            products[doc.data().id] = doc.data()
        });

        Object.assign(this.cache, products);
        return products;
    }

    async getProductsByIds(ids) {
        if (this.#checkCacheForIds(ids)) {
            return this.#getFromCacheByIds(ids);
        }

        const querySnapshot = await getDocs(query(productsRef, where('id', 'in', ids)));
        const products = {};
        querySnapshot.forEach((doc) => {
            products[doc.data().id] = doc.data()
        });

        Object.assign(this.cache, products);
        return products;
    }

    async getProduct(id) {
        if (this.cache[id]) {
            return this.cache[id];
        }

        const productRef = await doc(db, "products", id);
        const docSnap = await getDoc(productRef);
        const data = docSnap.data();
        if (data) {
            this.cache[data.id] = data;
        }

        return Object.assign({}, data);
    }

    async getAllProductsCount() {
        const snapshot = await getCountFromServer(productsRef);
        return snapshot.data().count;
    }

    async getValidProductsCountForSelectedItems(selectedCategories) {
        let ref = query(productsRef, where('disabled', '!=', true));
        if (selectedCategories.length) {
            ref = query(productsRef, where('disabled', '!=', true), where('categories', 'array-contains-any', selectedCategories));
        }

        const snapshot = await getCountFromServer(ref);
        return snapshot.data().count;
    }

    #checkCacheForIds = (ids) => {
        return !ids.map(id => this.cache.hasOwnProperty(id)).filter(exists => !exists).length;
    }

    #getFromCacheByIds = (ids) => {
        return ids.reduce((acc, id) => {
            acc[id] = this.cache[id];
            return acc;
        }, {});
    }
}


const ProductManager = new _ProductsManager();
export default ProductManager;